import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedSommelierService {

  private slug$ = new BehaviorSubject<string | null>(null);

  constructor(private router: Router) {
    // Al iniciar, intento hidratar desde localStorage
    const saved = localStorage.getItem('selectedSlug');
    if (saved) {
      this.slug$.next(saved);
    }
  }

  setSlug(slug: string) {
    this.slug$.next(slug);
    localStorage.setItem('selectedSlug', slug); // persiste
  }

  clearSlug() {
    this.slug$.next(null);
    localStorage.removeItem('selectedSlug');
  }

  /**
   * 🔹 Para suscribirse y reaccionar a cambios (Observable)
   */
  getSlug$(): Observable<string | null> {
    return this.slug$.asObservable();
  }

  /**
   * 🔹 Para obtener el valor actual inmediato
   */
  get currentSlugValue(): string | null {
    return this.slug$.value ?? localStorage.getItem('selectedSlug');
  }

  // Helper de navegación con slug
  navigate(path: string | string[], extras?: any) {
    const slug = this.currentSlugValue;
    if (!slug) {
      console.warn('Slug no definido, navegando sin slug');
      this.router.navigate(Array.isArray(path) ? path : [path], extras);
      return;
    }

    const fullPath = Array.isArray(path) ? [slug, ...path] : [slug, path];
    this.router.navigate(fullPath, extras);
  }
}
